import React from "react";
import {
  defineBlock,
  smartProps,
  useSmartProp,
  useInspectorControl,
} from "@smartfire/gutenberg-react";
import { MediaUpload, MediaUploadCheck } from "@wordpress/block-editor";
import { PanelBody, PanelRow, TextControl } from "@wordpress/components";
import style from "./block.module.scss";
import EditableText from "../shared/editable-text";
import Button from "../shared/button-icon";
import { Button as ButtonAdmin } from "@wordpress/components";
const ALLOWED_MEDIA_TYPES = ["application/pdf"];

function Inspector() {
  const [text, setText] = useSmartProp("textButton");
  const [file, setFile] = useSmartProp("file");
  return (
    <>
      <PanelBody title="Configuration bouton" initialOpen={true}>
        <PanelRow>
          <TextControl
            label={"Texte Bouton"}
            value={text}
            onChange={(value) => setText(value)}
          />
        </PanelRow>
        <PanelRow>
          Fichier pdf actuel : {file ? file.filename : "Pas de fichier"}
        </PanelRow>
        <PanelRow>
          <MediaUploadCheck>
            <MediaUpload
              onSelect={(file) => setFile(file)}
              allowedTypes={ALLOWED_MEDIA_TYPES}
              value={file ? file.id : null}
              render={({ open }) => (
                <ButtonAdmin isDefault onClick={open}>
                  Config fichier pdf
                </ButtonAdmin>
              )}
            />
          </MediaUploadCheck>
        </PanelRow>
      </PanelBody>
    </>
  );
}

function Block({ file, textButton }) {
  useInspectorControl(Inspector);
  return (
    <div className={style.block}>
      <EditableText
        tagName="h3"
        className={style.title}
        smartProp="title"
        placeholder={"Entrez un titre"}
      />
      <div className={style.bar} />
      <EditableText
        className={style.text}
        smartProp="text"
        placeholder={"Entrez un texte"}
      />
      {file && (
        <Button
          classIcon={style.icon}
          textColor={style.blueText}
          className={style.button}
          external
          href={file.url}
        >
          {textButton}
        </Button>
      )}
    </div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    text: smartProps.string.withDefault(""),
    title: smartProps.string.withDefault(""),
    textButton: smartProps.string.withDefault(""),
    file: smartProps.any.withDefault(null),
  },
  setup: {
    title: "Presse",
  },
});
